module.exports = __webpack_public_path__ + "img/1F632.4d7723f7.svg";